import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import ECharts from "vue-echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart, LineChart } from "echarts/charts";
import { GridComponent, TooltipComponent, ToolboxComponent, TitleComponent, LegendComponent } from "echarts/components";
use([CanvasRenderer, BarChart, PieChart, LineChart, GridComponent, TooltipComponent, ToolboxComponent, TitleComponent, LegendComponent]);


const app = createApp(App);
app.use(Antd);
app.component("v-chart", ECharts);
import { Button, Tabbar, TabbarItem, Card, Field, CellGroup, NavBar } from 'vant';
app.use(Button);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Card);
app.use(Field);
app.use(CellGroup);
app.use(NavBar);

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
app.use(VueViewer)

app.config.productionTip = false;
import BasicLayout from "./layouts/BasicLayout";
import EmptyLayout from "./layouts/EmptyLayout";
app.component("basic-layout", BasicLayout);
app.component("empty-layout", EmptyLayout);
import api from './request'
app.config.globalProperties.$api = api;
import utils from './utils';
app.config.globalProperties.$utils = utils;
app.config.globalProperties.$d = utils.d;
app.config.globalProperties.$dateFormat = utils.dateFormat;
import async from 'async';
app.config.globalProperties.$async = async;
import axios from 'axios'
app.config.globalProperties.$axios = axios;
import constant from './constant';
app.config.globalProperties.$constant = constant;

app.config.globalProperties.$filters = {
  dateFormat: utils.dateFormat,
  fromNow: utils.fromNow,
  filterOption: utils.filterOption,
  formatMoney: utils.formatMoney,
}
import './icons'
import SvgIcon from './components/svgicon/Index.vue'
app.component('svg-icon', SvgIcon)
app.use(router);
app.use(store);
app.mount("#app");
